import { IconFileTypeDocx } from '@tabler/icons-react';

import { Button, Tooltip } from '@mantine/core';

import { IdentityType } from '../../auth/IdentityType';

interface ExportButtonProps {
    exportDocx: () => void;
    userIdentity: IdentityType;
    documentContent: string;
}

const ToolbarExportDocxButton = (props: ExportButtonProps) => {
    const hasCostEstimate =
        props.documentContent.includes('::costEstimate') ||
        props.documentContent.includes('<CostEstimate');
    const hasFinanceAccess =
        props.userIdentity === IdentityType.Admin ||
        props.userIdentity === IdentityType.FinanceController;
    const isDisabled = hasCostEstimate && !hasFinanceAccess;

    const title = isDisabled
        ? 'Export to DOCX (requires Finance Controller role for cost estimates)'
        : 'Export to DOCX';

    return (
        <Tooltip label={title} position="bottom">
            <Button
                variant="light"
                color="secondary"
                size="compact-xs"
                fw={600}
                leftSection={<IconFileTypeDocx size={14} />}
                onClick={isDisabled ? undefined : props.exportDocx}
                disabled={isDisabled}
            >
                Export to DOCX
            </Button>
        </Tooltip>
    );
};

export default ToolbarExportDocxButton;
